module.exports = __webpack_public_path__ + "assets/img/30a3a18178f7a44012b3ab59fadf9851.webp";